import { SubscriptionResponse } from "@/services/datatypes/api";
import { TYPO3_API_TIMEOUT, TYPO3_BASE_URL } from "@/services/globals";
import { usePersistSecureBoundStore } from "@/services/zustand/Store";
import { fetchWithTimeout } from "../fetchWithTimeout";

export const useGetSubscriptions = () => {
    const user = usePersistSecureBoundStore((state) => state.user);

    const getSubscriptions = async (jwt: string): Promise<SubscriptionResponse> => {
        //console.log("getSubscriptions");
        try {
            const response = await fetchWithTimeout(`${TYPO3_BASE_URL}subscriptions/?jwt=${jwt}`, {}, TYPO3_API_TIMEOUT);
            const data = await response.json();
            return {
                ...data,
                ok: response.ok,
            };
        } catch (err: any) {
            if (err.name === 'AbortError') {
                console.log("Request timed out!");
            } else {
                console.error("Request error:", err.message);
            }

            return {
                entries: user?.subscriptions ?? [],
                lastUpdated: 0,
                ok: false,
            };
        }
    };
    return { getSubscriptions };
};